const initialState = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  email: '',
  mobileNumber: '',
  password: '',
  confirmPassword: '',
  guardianFirstName: '',
  guardianLastName: '',
  isMinor: false,
  country: '',
  confirmCountryChecked: false,
  gender: '',
  birthCountry: '',
  birthZipCode: ''
};
export { initialState };